<template>
  <div class="login">
    <!-- <div class="logo">
      <img src="../../assets/img/logo.png" alt="" srcset="">
    </div> -->
    <div class="login-box">
      <div class="content">
        <div class="title">欢迎登录</div>
        <div class="sub-title">请使用您本人的账号密码登录</div>
        <div class="mid">
          <el-form :model="dataForm"
            class="form-box"
            :rules="dataRule"
            ref="dataForm"
            @keyup.enter.native="dataFormSubmit()"
            status-icon>
          <el-form-item prop="userName" label="" class="info">
            <el-input
              ref="userName"
              v-model="dataForm.userName"
              placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="" class="info">
              <el-input
                v-model="dataForm.password"
                ref="password"
                type="password"
                autocomplete="new-password"
                show-password
                placeholder="请输入密码"></el-input>
            </el-form-item>
            <div class="btns">
              <el-checkbox v-model="checked" @change="remberPS">记住密码</el-checkbox>
              <el-button type="text" @click="forgetPassword">忘记密码?</el-button>
            </div>  
            <el-form-item>
              <div class="item-btn"><input type="button" value="登录" @click="login" class="submit"></div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer">Copyright©2016-{{ new Date().getFullYear() }} 二一三ELYSAN.com 版权所有</div>
    <div class="footer footer2"><img src="@/assets/img/gongan.png"  width="20" height="20" style="margin-right: 10px;"/><a href="https://beian.mps.gov.cn/#/query/webSearch?code=21010602001127" rel="noreferrer" target="_blank" style="margin-right: 10px;">辽公网安备21010602001127</a>  辽ICP备2024031717号-2</div>
  </div>
</template>

<script>
import { login } from '@/api/login'
import { getUserMenue } from '@/api/menu'

export default {
  data () {
    const nickNameCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('账号不能为空'))
      }
      setTimeout(() => {
        const reg = /^[0-9A-Za-z]+$/
        if (!reg.test(value)) {
          callback(new Error('必须是数字、英文字母'))
        } else if (value.length > 20 || value.length < 4) {
          callback(new Error('长度在 4 到 20 '))
        } else {
          callback()
        }
      }, 700)
    }
    return {
      dataForm: {
        userName: '',
        password: '',
        uuid: ''
      },
      dataRule: {
        userName: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          { validator: nickNameCheck, trigger: 'blur'}
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20', trigger: 'blur'}
        ]
      },
      captchaPath: '',
      checked: false
    }
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.handerKeyup)
  },
  mounted () {
    // this.getCaptcha()
    if (!this.dataForm.userName) {
      this.$refs.userName.focus()
    } else if (!this.dataForm.password) {
      this.$refs.password.focus()
    }
    if (localStorage.getItem('userName')) {
      this.dataForm.userName = localStorage.getItem('userName')
    }
    if (localStorage.getItem('password')) {
      this.dataForm.password = localStorage.getItem('password')
    }
    this.$nextTick(() => {
      this.checked = JSON.parse(window.localStorage.isRemberPS || '{}')
    })
    document.addEventListener('keydown', this.enterEvent)
  },
  destroyed () {
    document.removeEventListener('keydown', this.enterEvent)
  },
  methods: {
    enterEvent (e) {
      if (e && (e.keyCode === 13 || e.which === 13)) {
        this.login()
      }
    },
    forgetPassword () {
      this.$message({
        message: '请联系管理员修改！',
        type: 'warning'
      })
    },
    // 提交表单
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$refs.verify.show()
        }
      })
    },
    login () {
      if (this.isSubmit) {
        return
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.isSubmit = true
          login({
            userName: this.dataForm.userName,
            passWord: this.dataForm.password
          }).then(async ({ data }) => {
            this.$cookie.set('Authorization', data.accessToken)
            const { data: myData = {} } = await getUserMenue()
            const { menuList = [] } = myData
            if (menuList.length) {
              // this.$store.commit('user/SET_MENU', menuList)
              const showPage = menuList[0] || {}
              const {url, list = []} = showPage
              if (url) {
                this.$router.replace({ path: `/management-system/${url}` })
              } else {
                const childRoute = list[0] || {}
                const {url} = childRoute
                this.$router.replace({ path: `/management-system/${url}` })
              }
            }
          }).catch(() => {
            this.isSubmit = false
          })
          if (this.checked) {
            localStorage.setItem('userName', this.dataForm.userName)
            localStorage.setItem('password', this.dataForm.password)
          } else {
            localStorage.setItem('userName', this.dataForm.userName)
            localStorage.removeItem('password')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
      sessionStorage.clear()
    },
    remberPS (v) {
      window.localStorage.setItem('isRemberPS', v)
    }
    // dataFormSubmit () {
    //   this.$refs['dataForm'].validate((valid) => {
    //     if (valid) {
    //       this.$http({
    //         url: this.$http.adornUrl('/login?grant_type=admin'),
    //         method: 'post',
    //         data: this.$http.adornData({
    //           'principal': this.dataForm.userName,
    //           'credentials': this.dataForm.password,
    //           'sessionUUID': this.dataForm.uuid,
    //           'imageCode': this.dataForm.captcha
    //         })
    //       }).then(({ data }) => {
    //         this.$cookie.set('Authorization', 'bearer' + data.access_token)
    //         this.$router.replace({ name: 'home' })
    //       }).catch(() => {
    //         this.getCaptcha()
    //       })
    //     }
    //   })
    // },
    // 获取验证码
    // getCaptcha () {
    //   this.dataForm.uuid = getUUID()
    //   this.captchaPath = this.$http.adornUrl(`/captcha.jpg?uuid=${this.dataForm.uuid}`)
    // }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-checkbox {
  color: #51BA99;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  font-size: 29px;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #00af84;
  border-color:#fff;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 8px;
  left: 10px;
  position: absolute;
  top: 5px;
  width: 3px;
  // transition: transform .15s ease-in .05s;
  transform-origin: center;
  transform: rotate(45deg) scaleY(1.3);
}
::v-deep .el-checkbox__input .el-checkbox__inner::after {
  left: 10px;
  top: 5px;
  transform-origin: center;
  transform: rotate(45deg) scaleY(1.3);
}

::v-deep .el-checkbox__inner {
  width: 22px;
  height: 22px;
  top: -1.2px;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color:#fff;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #51BA99;
}
.login {
  width: 100%;
  height: 100%;
  background: url(~@/assets/img/login-bg1.png) no-repeat;
  background-size: 100% 100%;
  position: fixed;
}
.logo {
  padding: 35px 0 0 50px;
}
.login .login-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login .login-box .content {
  width: 76%;
  height: 63%;
  padding-top: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content:center;
  justify-content:space-between;
}
.login .login-box .title {
  width: 50%;
  margin-left: 47%;
  text-align: center;
  font-weight: bold;

  font-family: MiSans;
  font-weight: 400;
  font-size: 50px;
  color: #51BA99;
}
.login .login-box .sub-title{
  width: 50%;
  margin-left: 47%;
  text-align: center;

  font-family: MiSans;
  font-weight: 400;
  font-size: 26px;
  color: #9289A6;
}
.login .login-box .mid {
  width: 70%;
  height:70%;
  margin-left: 37.5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  .form-box{
    height:100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .info{
      margin-bottom: 50px;
    }
  }
}
::v-deep .el-form {
  width: 50%;
  font-family: MiSans;
  & .el-form-item__label {
    font-size: 17px;
    color: #fff;
    font-weight: 500;
    font-family: MiSans;
  }
  & .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    display: none;
  }
  & .el-input {
    background: #F4F8F7 ;
  }
  & .el-input__inner {
    padding: 30px 20px;
    border: 0;
    background: #F4F8F7 ;
    border-bottom: 1px solid rgba(255,255,255,0.4);
    border-radius: 0;

    font-family: MiSans;
    font-weight: 400;
    font-size: 26px;
    color: #9289A6;
    height:50px;
  }
  // & .el-input__inner::placeholder {
  //   font-size: 18px;
  //   font-weight: 500;
  //   color: rgba(247, 247, 247, 0.4);
  // }
  & .el-input__inner:focus {
    border-color: #fff;
  }
  & .el-form-item.is-success .el-input__inner {
    border-color: #fff;
  }
  & .el-form-item__error {
    color: #c7344f;
    font-size: 14px;
    font-family: MiSans;
  }
  & .el-form-item.is-error .el-input__inner {
    border-color: #c7344f;
  }
  // & .el-input__suffix {
  //   display: none;
  // }
}

::v-deep input:-webkit-autofill {
  // 字体颜色
  -webkit-text-fill-color: #9289A6 !important;
  // 背景颜色
  background-color:transparent !important;
  //设置input输入框的背景颜色为透明色
  -webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;  
  transition: background-color 50000s ease-in-out 0s;  
}
::v-deep input:-webkit-autofill::first-line {
  font-size: 26px !important;
}

.btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 70px;
}
.btns ::v-deep .el-button {
  padding: 6px 0px;
  font-weight: 400;
}
.btns ::v-deep .el-button--text {
  font-family: Adobe Heiti Std;
  font-weight: normal;
  font-size: 26px;
  color: #51BA99;
  padding-left: 10px;
}
.btns ::v-deep .el-checkbox__label {
  font-family: Adobe Heiti Std;
  font-weight: normal;
  font-size: 26px;
}

.login .login-box .mid .item-btn input {
  border: 0;
  width: 100%;
  height: 68px;
  box-shadow: 0;
  color: #fff;
  font-family: MiSans;
  font-size: 24px;
  font-weight: 500;
  cursor: pointer;

  background: #51BA99;
  box-shadow: 0px 5px 15px 0px rgba(58,170,168,0.5);
  border-radius: 40px;
}
.bottom {
  width: 50%;
  position: absolute;
  right: 0;
  bottom: 0.42rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #F7F7F7;
  font-size: 19px;
  .dot {
    margin: 0 10px;
    color: rgba(247,247,247,0.17);
  }
}

.login .footer {
  position: absolute;
  bottom:45px;
  left: 0;
  width: 100%;
  color: #A5A5A5;
  font-size: 13px;
  text-align: center;
  z-index:10;
  font-family: Source Han Sans CN;
  font-weight: 300;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login .footer2{
  bottom:20px;
}
.submit{
  font-size: 36px;
  font-family: 59;
  font-weight: 400;
}
</style>
